export { default as Component } from "@gradio/code";
export const modes = ["static", "dynamic"];
